/**
 * Media Query Listener für Responsive Table
 */

const query = '(max-width: 979px)';

export default function initResponsiveTables() {
  const mq = window.matchMedia(query);
  mq.addListener(widthChange);
  widthChange(mq);
}

export function updateResponsiveTables() {
  widthChange(window.matchMedia(query));
}

function widthChange(mq) {
  if (!mq.matches) {
    return;
  }

  [...document.querySelectorAll('.table:not(.table-unresponsive)')].forEach(elem => {
    const headColCount =  elem.querySelectorAll('thead tr th').length;
    for (let i=0; i <= headColCount; i++)  {
      const headCol = elem.querySelector(`thead tr th:nth-child(${i})`);
      if (headCol) {
        const headColLabel = headCol.textContent;
        [...elem.querySelectorAll(`tr td:nth-child(${i})`)].forEach(td => td.setAttribute('data-label', headColLabel));
      }
    }
  });
}
